export const apiTypes = {
  ADRESSE: "ADRESSE",
  ENTREPRISE: "ENTREPRISE",
  INSEE: "INSEE",
};

export const apiLabels = {
  ADRESSE: "La base d'adresses de DataGouv",
  ENTREPRISE: "La source de données Entreprise (API Entreprise)",
  INSEE: "La source de données entreprise de l'INSEE (API Insee)",
};
